import { StylesProvider } from "@material-ui/core";
import { isAfter } from "date-fns";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";


const styles={
    body:{ width:'70%',margin:'0 auto',display:'flex',justifyContent:'space-between',flexWrap:'wrap' },
    errorText:{width:'100%', textAlign:'center',marginTop:'1rem', color:'red'}
}


const DateModal = ({
    show = false,
    title = "Seleccione una Fecha",
    onClose = () => {},
    onConfirm = () => {},
}) => {

    const [dateFrom,setDateFrom]=useState(null)
    const [dateTo,setDateTo]=useState(null)
    const [error,setError]=useState('')


    function handleChange(e){
        const name = e.target.name
        const date = e.target.value
        name === 'from' ? setDateFrom(date) : setDateTo(date)
    }

    function handleConfirm(){
        if(dateFrom && dateTo){
            if(isAfter(new Date(dateTo), new Date(dateFrom)) ){
                onConfirm(dateFrom,dateTo)
            }else{
                //show mesg
                setError('Por Favor, Revise las fechas ingresadas')
            }
        }else{
            setError('Debe ingresar fechas validas')
        }
    }

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div style={styles.body}>
                    <div>
                        <label htmlFor="">Desde</label>
                        <br />
                        <input name="from" onChange={handleChange} type="date" />
                    </div>

                    <div>
                        <label htmlFor="">Hasta</label>
                        <br />
                        <input name="to" onChange={handleChange} type="date" />
                    </div>
                </div>
                {error && <p style={styles.errorText}>{error}</p>}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    bsStyle="primary"
                    onClick={handleConfirm}
                    style={{ minWidth: "100px", marginRight: "16px" }}
                >
                    Seleccionar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DateModal;



// WEBPACK FOOTER //
// ./src/scenes/reportes/components/DateModal.js